// External libraries
import React from 'react';
import { useStoreState } from '@/store';
// @ts-expect-error untyped-import
import { FloatingLabelSelect } from '@checkout/react-components';

// Internal modules
import { features, getContent } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';
// @ts-expect-error untyped-import
import { blurHandler, changeHandler, focusHandler } from './handlers';
import { getNationalityBasedKycValue } from '@/lib/features/utils';
import type { GenericObjectType } from '@/types';

export type IdentityDocumentTypeProps = {
  blurHandler?: (e: React.FocusEvent<HTMLInputElement>) => void;
  changeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
  focusHandler?: (e: React.FocusEvent<HTMLInputElement>) => void;
  nationality?: GenericObjectType;
};

const IdentityDocumentType = (
  props: IdentityDocumentTypeProps,
): JSX.Element => {
  useMountLogging('IdentityDocumentType');
  const identityDocumentType = useStoreState(
    ({ form }) => form.identityDocumentType,
  );

  const nationality = useStoreState(({ form }) => form.nationality) || {};

  const availableKycTypes = getNationalityBasedKycValue(
    features.config.kycIdTypes,
    // @ts-expect-error don't use default object
    nationality?.value,
  );

  const identityDocumentTypeOptions = availableKycTypes.map((type: string) => {
    return {
      text: getContent(`fieldValues.${type}`),
      value: type,
    };
  });
  const theme = features.get('rebrandFormFieldsTheme');

  return (
    <FloatingLabelSelect
      blurHandler={blurHandler}
      changeHandler={changeHandler}
      focusHandler={focusHandler}
      id="identityDocumentType"
      label={getContent('fieldLabels.identityDocumentType')}
      required={true}
      selectOptions={identityDocumentTypeOptions}
      theme={theme}
      {...identityDocumentType}
    />
  );
};

export { IdentityDocumentType };
